const formatToUTC = (date) => {
  if (!date) return null;

  const d = new Date(date);
  const utcMidnight = new Date(
    Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())
  );
  return utcMidnight.toISOString(); // Outputs: 'YYYY-MM-DDT00:00:00.000Z'
};

export default formatToUTC;
